import React from 'react';
import ProfilePageComponent from '../components/profile';

const ProfilePage = () => {
  return (
    <ProfilePageComponent />
  );
};

export default ProfilePage; 